import React from 'react';
import { useDispatch } from 'react-redux';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Button from '@amzn/meridian/button';
import {
  setIsCreateModalOpen,
  setSearchField,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppSelector } from 'src/store/store';

/**
 * Default component
 */
const TopOptions = () => {
  const dispatch = useDispatch();
  const { searchField } = useAppSelector((state) => state.taskConfigPage);
  const { featureFlags } = useAppSelector((state) => state.user);

  return (
    <Row widths={['80%', '20%']} spacingInset="400 none" alignmentHorizontal="justify">
      {/* Search Field */}
      <Row width="grid-4">
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
        />
      </Row>

      {/* Buttons */}
      {!featureFlags.TASK_GROUPING ? (
        <Row width="grid-4" alignmentHorizontal="end">
          <Button type="secondary" onClick={() => ({})}>
            Create Group
          </Button>
          <Button className="view-and-edit-tasks__open-modal" onClick={() => dispatch(setIsCreateModalOpen(true))}>
            Add Task
          </Button>
        </Row>
      ) : (
        <Button className="view-and-edit-tasks__open-modal" onClick={() => dispatch(setIsCreateModalOpen(true))}>
          Add Tasks/Measurements
        </Button>
      )}
    </Row>
  );
};

export default TopOptions;
